import {webRequest, webNoTokenRequest} from '../api'

// 合約版本列表
export function getContractVersionList() {
    return webRequest({
        url:'/v1/oauth/management/contract/version/list',
        method:'get',
    })
}

// 取得合約版本內容
export function getContractVersionContent(params) {
    return webRequest({
        url:'/v1/oauth/management/contract/version/edit/page',
        method:'get',
        params: params
    })
}
// 預覽合約版本
export function previewContractVersion(params) {
    return webRequest({
        url:'/v1/oauth/management/contract/version/preview',
        method:'get',
        params: params
    })
}
// 新增編輯預覽合約版本
export function previewEditContractVersion(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/version/preview',
        method:'post',
        data: data
    })
}
// 新增編輯合約版本
export function editContractVersion(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/edit/version',
        method:'post',
        data: data,
    })
}
// 刪除合約版本
export function deleteContractVersion(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/delete/version',
        method:'post',
        data: data,
    })
}
// 取得房源合約版本
export function getHouseContractVersion(params) {
    return webRequest({
        url:'/v1/oauth/management/house/get/contractVersion',
        method:'get',
        params: params
    })
}
// 批量套用合約版本
export function batchContractVersion(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/batch/set/version',
        method:'post',
        data: data,
    })
}
// 合約版本上傳附件pdf
export function uploadPdf(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/version/upload/attached',
        method:'post',
        data: data,
    })
}
// 刪除合約版本附件pdf
export function delPdf(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/version/delete/attached',
        method:'post',
        data: data,
    })
}



// WEBPACK FOOTER //
// ./src/apis/company/contractVersion.js